import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import LandingPageLayout from 'components/LandingPageLayout';
import AboutUsSlider from 'components/LandingPageAboutUsSlider';
import Head from 'next/head';
const SoulroomsDemoCall = () => {
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>SoulRooms Demo call</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://www.soulrooms.com/soulrooms-demo-call" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@SoulRoomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta name="twitter:description" content="SIMPLIFIED shared living FOR AWESOME PEOPLE" />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/stock/107964" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <link rel="canonical" href="https://www.soulrooms.com/soulrooms-demo-call" />
      </Head>
      <LandingPageLayout>
        <div>
          <HeadingSection title="SELECT THE TIME THAT SUITS YOU FOR A BRIEF CHAT" bgcolor="white" />

          {/* <iframe width={'100%'} height={660} src={'/static/demoCall/index.html'} /> */}

          <iframe
            id="iframe-05"
            frameborder="0"
            width="100%"
            height="100vh"
            style={{ overflow: 'none', height: '660px' }}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation allow-top-navigation"
            src='https://calendly.com/srdemo/30-min-discussion?hide_gdpr_banner=1&primary_color=fcb000'
          ></iframe>
        </div>

        <AboutUsSlider heading="Featured in:" bg={'black'} />
      </LandingPageLayout>
    </>
  );
};

export default SoulroomsDemoCall;
